namespace TabAurous.Production {
    export interface TreeMakingBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        BomProductId?: number;
        CalcOnId?: number;
        AttributeId?: number;
        ItemTypeId?: number;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefTransBomId?: number;
        IsExisting?: boolean;
        Markup?: number;
        SettingId?: number;
        SettingName?: string;
        StoneStatusId?: number;
        StoneStatusName?: string;
        Lab?: string;
        CertificateNo?: string;
        IsCustomerItem?: boolean;
    }

    export namespace TreeMakingBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.TreeMakingBOM';
        export const lookupKey = 'Production.TreeMakingBOM';

        export function getLookup(): Q.Lookup<TreeMakingBOMRow> {
            return Q.getLookup<TreeMakingBOMRow>('Production.TreeMakingBOM');
        }
        export const deletePermission = 'Production:TreeMaking:Delete';
        export const insertPermission = 'Production:TreeMaking:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:TreeMaking:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            ItemTypeId = "ItemTypeId",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefTransBomId = "RefTransBomId",
            IsExisting = "IsExisting",
            Markup = "Markup",
            SettingId = "SettingId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            StoneStatusName = "StoneStatusName",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            IsCustomerItem = "IsCustomerItem"
        }
    }
}
